module.exports = __webpack_public_path__ + "media/images/error_page_picture-f3f3fb66771018aca26307e807cd8ca5.png";